import React from 'react';

import PromoExplanation from '../../block/promoExplanation/Component';
import { PropsFromInputs } from '../../types';

import { ItemsContainer, ItemsOuterContainer } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ items = [] }: Props) => {
  return (
    <ItemsOuterContainer>
      <ItemsContainer>
        {items.map(item => (
          <PromoExplanation key={`${item.reward}-${item.order}`} {...item} />
        ))}
      </ItemsContainer>
    </ItemsOuterContainer>
  );
};
